/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
 * filtertool-capabilities.ts
 * Gegenereerd met Junie (AI), 06-10-2025
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Helpers en interfaces voor mogelijkheden van filtertoolregels per doeltype.
 */

import type { Planitem as PlanitemType } from '../../models/planitem';
import type { Functie as FunctieType } from '../../models/functie';
import type { Personeel as PersoneelType } from '../../models/personeel';
import type { Filtertoolregel } from './filtertool-regels';

/**
 * Interface voor regels die toepasbaar zijn op Planitems.
 */
export interface PlanitemFilterbareRegel {
  /** Past deze regel toe op één planitem en geeft aan of het item matcht. */
  filterPlanitem(pi: PlanitemType): boolean;
}

/**
 * Interface voor regels die toepasbaar zijn op Functies.
 */
export interface FunctieFilterbareRegel {
  /** Past deze regel toe op één Functie en geeft aan of het item matcht. */
  filterFunctie(f: FunctieType): boolean;
}

/**
 * Interface voor regels die toepasbaar zijn op Personeel.
 */
export interface PersoneelFilterbareRegel {
  /** Past deze regel toe op één Personeel en geeft aan of het item matcht. */
  filterPersoneel(persoon: PersoneelType): boolean;
}

/**
 * Typeguard: controleert of een regel een planitem-filtermethode aanbiedt.
 */
export function heeftPlanitemFilter(regel: Filtertoolregel | unknown): regel is PlanitemFilterbareRegel {
  return !!regel && typeof (regel as any).filterPlanitem === 'function';
}

/**
 * Typeguard: controleert of een regel een functie-filtermethode aanbiedt.
 */
export function heeftFunctieFilter(regel: Filtertoolregel | unknown): regel is FunctieFilterbareRegel {
  return !!regel && typeof (regel as any).filterFunctie === 'function';
}

/**
 * Typeguard: controleert of een regel een personeel-filtermethode aanbiedt.
 */
export function heeftPersoneelFilter(regel: Filtertoolregel | unknown): regel is PersoneelFilterbareRegel {
  return !!regel && typeof (regel as any).filterPersoneel === 'function';
}
